import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { OrganizationContext } from "../../../Services/OrganizationContext";
import authService from "../../../Services/authService";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import jsPDF from "jspdf";
import html2canvas from 'html2canvas';

const LabCashCollect = () => {
  const { id } = useParams();
  const { organization } = useContext(OrganizationContext);
  const [OrderInf, setData] = useState({});
  const [cashCollected, setCashCollected] = useState(false);

  useEffect(() => {
    if (organization) {
      loadOrdersInfo();
    }
  }, [organization]);

  const loadOrdersInfo = async () => {
    try {
      const token = authService.getCurrentadmin()?.token;
      if (!token) return;

      const response = await fetch(`${authService.getApiUrl()}laboratorydetails`, {
        method: "POST",
        body: JSON.stringify({ order_id: id }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      setData(result?.data?.[0] || {});
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const updateOrderStatus = (data) => {
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'labcodcollected/' + data.order_id, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(result => {
        loadOrdersInfo();
        setCashCollected(true);
      })
      .catch(err => console.error(err.message));
  };
  const invoiceRef = useRef();

const handleDownloadInvoice = async () => {
  const input = invoiceRef.current;
  if (!input) return;

  try {
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Add first page
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    // Add more pages if needed
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`Invoice_${OrderInf.invoice_number || "Order"}.pdf`);
  } catch (err) {
    console.error("PDF generation failed", err);
  }
};


  return (
    <div className="main-container">
      <div className="container-fluid">
        <Breadcrumb />
        <div className="category-table">
          <div className="flex-cont add-cat">
            <div className="heading">
              <h3>Collect Cash</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" >
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="full-cont">
                      <div className="user-table first-table">
                        <div className="user-role">
                          <table
                            key={OrderInf?.order_id}
                            border="1"
                            cellSpacing="0"
                            cellPadding="10"
                            style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}
                          >
                            <tbody>
                              {/* Always show Invoice Number */}
                              <tr>
                                <td colSpan="5">
                                  <strong>Invoice Number:</strong> {OrderInf?.invoice_number || "N/A"}
                                </td>
                              </tr>

                              {/* Show headers and product rows if tests exist */}
                              {OrderInf?.orders_items?.products?.length > 0 && (
                                <>
                                  <tr>
                                    <td><strong>Patient Name</strong></td>
                                    <td><strong>Test Name</strong></td>
                                    <td><strong>Quantity</strong></td>
                                    <td><strong>Preparation</strong></td>
                                    <td><strong>Visit Type</strong></td>
                                  </tr>
                                  {OrderInf.orders_items.products.map((items, index) => (
                                    <tr key={`product-${items.id || index}`}>
                                      <td>{items.family_member_name || "N/A"}</td>
                                      <td>{items.test_name || "N/A"}</td>
                                      <td>{items.quantity || "N/A"}</td>
                                      <td>{items.preparation || "N/A"}</td>
                                      <td>{items.visit_type || "N/A"}</td>
                                    </tr>
                                  ))}
                                </>
                              )}

                              {/* Show package details if packages exist */}
                              {OrderInf?.orders_items?.packages?.length > 0 && (
                                <>
                                  {OrderInf.orders_items.packages.map((pitems, index) => (
                                    <React.Fragment key={`package-${pitems.id || index}`}>
                                      <tr>
                                        <td colSpan="2">
                                          <strong>Package Name:</strong> {pitems.test_name || "N/A"}
                                        </td>
                                        <td colSpan="2">
                                          <strong>Patient Name:</strong> {pitems.family_member_name || "N/A"}
                                        </td>
                                        <td>{pitems.visit_type || "N/A"}</td>
                                      </tr>
                                      <tr>
                                        <td colSpan="2"><strong>Category Name</strong></td>
                                        <td><strong>Test Names</strong></td>
                                      </tr>
                                      {pitems.lab_tests?.map((psubitems, subIndex) => (
                                        <tr key={`lab-test-${psubitems.id || subIndex}`}>
                                          <td colSpan="2">{psubitems.category_name || "N/A"}</td>
                                          <td colSpan="2">{psubitems.test_name || "N/A"}</td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ))}
                                </>
                              )}

                              {/* ✅ Slot Date & Time shown at the end */}
                              <tr>
                                <td colSpan="5">
                                  <strong>Slot:</strong>{" "}
                                  {OrderInf?.slot_date ? `${OrderInf.slot_date} at ${OrderInf.slot_time}` : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="5">
                                  <strong>Due AMount : </strong>{" "}
                                  <strong className="text-red-500">{OrderInf?.due_amount}</strong>
                                </td>
                              </tr>

                            </tbody>


                          </table>
                        </div>
                      </div>
                      <div className="submit-section mt-0 pt-0">
                        {/* Show Collect Cash button only if due_amount is not 0 */}
                        {parseFloat(OrderInf?.due_amount) !== 0 && (
                          <button
                            className="btn btn-primary submit-btn"
                            type="button"
                            onClick={(event) => updateOrderStatus(OrderInf)}
                          >
                            Collect Cash
                          </button>
                        )}

                        {/* Show Download button if due_amount is 0 */}
                        {parseFloat(OrderInf?.due_amount) === 0 && OrderInf?.invoice_number && (
                          <button onClick={handleDownloadInvoice} type="button" className="btn btn-success">
                            Download Invoice
                          </button>
                        )}

                      </div>

                      {cashCollected && <div className="alert alert-success mt-3">Cash collected successfully. You can now download the invoice.</div>}

                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        id="styled-invoice"
        ref={invoiceRef}
        style={{
          position: 'absolute',
          left: '-9999px',
          top: 0,
          width: '800px',
          backgroundColor: '#ffffff',
          padding: '20px',
          fontSize: '12px',
          fontFamily: 'Arial, sans-serif',
          color: '#000',
          fontWeight: 'normal', // ✅ Avoid bold bleeding
          WebkitFontSmoothing: 'antialiased', // ✅ Better font rendering on WebKit (Chrome, Safari)
          MozOsxFontSmoothing: 'grayscale', // ✅ Better rendering on Firefox/macOS
        }}
      >

        {/* Invoice Header */}
        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
          {/* Logo - optional */}

          <img
            src="/images/pranaam-365-logo.png"
            alt="Hospital Logo"
            style={{ height: '50px', marginBottom: '4px' }}
          />


          {/* Tax Invoice Title */}
          <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, color: '#000', marginBottom: '25px' }}>Tax Invoice</h2>
        </div>






        {/* Invoice Meta Info */}
        <table style={{ width: '100%', marginBottom: '12px', color: '#000' }}>
          <tbody>
            <tr>
              <td><strong>Invoice No:</strong></td>
              <td>{OrderInf.invoice_number}</td>
            </tr>
            <tr>
              <td><strong>Invoice Date:</strong></td>
              <td>{new Date(OrderInf.orderdate).toLocaleDateString('en-IN')}</td>
            </tr>

          </tbody>
        </table>

        {/* Order Summary Table */}
        <h3 style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#000' }}>Order Summary</h3>
        <table
          key={OrderInf?.order_id}
          cellSpacing="0"
          cellPadding="10"
          style={{
            width: "100%",
            textAlign: "left",
            marginBottom: "20px",
            borderCollapse: "collapse",
          }}
        >
          <tbody>
            <tr>
              <td colSpan="5" style={{ border: "1px solid #000", padding: "5px" }}>
                <strong>Invoice Number:</strong> {OrderInf?.invoice_number || "N/A"}
              </td>
            </tr>

            {OrderInf?.orders_items?.products?.length > 0 && (
              <>
                <tr>
                  {["Patient Name", "Test Name", "Quantity", "Preparation", "Visit Type"].map((heading) => (
                    <td key={heading} style={{ border: "1px solid #000", fontWeight: "bold", padding: "5px" }}>{heading}</td>
                  ))}
                </tr>
                {OrderInf.orders_items.products.map((items, index) => (
                  <tr key={`product-${items.id || index}`}>
                    <td style={{ border: "1px solid #000", padding: "5px" }}>{items.family_member_name || "N/A"}</td>
                    <td style={{ border: "1px solid #000", padding: "5px" }}>{items.test_name || "N/A"}</td>
                    <td style={{ border: "1px solid #000", padding: "5px" }}>{items.quantity || "N/A"}</td>
                    <td style={{ border: "1px solid #000", padding: "5px" }}>{items.preparation || "N/A"}</td>
                    <td style={{ border: "1px solid #000", padding: "5px" }}>{items.visit_type || "N/A"}</td>
                  </tr>
                ))}
              </>
            )}

            {OrderInf?.orders_items?.packages?.length > 0 && (
              <>
                <tr>
                  <td colSpan="5" style={{ border: "1px solid #000", padding: "5px", fontWeight: "bold", textAlign: "center" }}>
                    Package Details
                  </td>
                </tr>
                {OrderInf.orders_items.packages.map((pitems, index) => (
                  <React.Fragment key={`package-${pitems.id || index}`}>
                    <tr>
                      <td colSpan="2" style={{ border: "1px solid #000", padding: "5px" }}>
                        <strong>Package Name:</strong> {pitems.test_name || "N/A"}
                      </td>
                      <td colSpan="2" style={{ border: "1px solid #000", padding: "5px" }}>
                        <strong>Patient Name:</strong> {pitems.family_member_name || "N/A"}
                      </td>
                      <td style={{ border: "1px solid #000", padding: "5px" }}>
                        <strong>Visit Type:</strong> {pitems.visit_type || "N/A"}
                      </td>
                    </tr>

                    {/* Category + Lab Tests Table Header */}
                    <tr>
                      <td colSpan="2" style={{ border: "1px solid #000", padding: "5px", fontWeight: "bold" }}>Category Name</td>
                      <td colSpan="3" style={{ border: "1px solid #000", padding: "5px", fontWeight: "bold" }}>Test Name</td>
                    </tr>

                    {/* Lab Tests */}
                    {pitems.lab_tests?.map((psubitems, subIndex) => (
                      <tr key={`lab-test-${psubitems.id || subIndex}`}>
                        <td colSpan="2" style={{ border: "1px solid #000", padding: "5px" }}>{psubitems.category_name || "N/A"}</td>
                        <td colSpan="3" style={{ border: "1px solid #000", padding: "5px" }}>{psubitems.test_name || "N/A"}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </>
            )}


            <tr>
              <td colSpan="5" style={{ border: "1px solid #000", padding: "5px" }}>
                <strong>Slot:</strong> {OrderInf?.slot_date ? `${OrderInf.slot_date} at ${OrderInf.slot_time}` : "N/A"}
              </td>
            </tr>

            <tr>
              <td colSpan="5" style={{ border: "1px solid #000", padding: "5px" }}>
                <strong>Due Amount:</strong>{" "}
                <strong style={{ color: "#000" }}>{OrderInf?.due_amount}</strong>
              </td>
            </tr>
            <tr>
              <td colSpan="5" style={{ border: "1px solid #000", padding: "5px" }}>
                <strong>Total Amount:</strong>{" "}
                <strong style={{ color: "#000" }}>{OrderInf?.final_price}</strong>
              </td>
            </tr>
          </tbody>
        </table>



      </div>

    </div>

  );
};

export default LabCashCollect;
